import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
type ResponsiveType = {
  [key: string]: {
    breakpoint: { max: number; min: number };
    items: number;
    partialVisibilityGutter?: number;
  };
};

interface ReusableCarouselProps {
  items: any[];
  renderItem: (item: any, index: number) => React.ReactNode;
  responsive: ResponsiveType;
  infinite?: boolean;
  autoPlay?: boolean;
  showDots?: boolean;
  arrows?: boolean;
  itemClass?: string;
  containerClass?: string;
}

const ReusableCarousel: React.FC<ReusableCarouselProps> = ({
  items,
  renderItem,
  responsive,
  infinite = true,
  autoPlay = false,
  showDots = false,
  arrows = true,
  itemClass = "carousel-item",
  containerClass = "carousel-container",
}) => {
  return (
    <Carousel
      responsive={responsive}
      infinite={infinite}
      autoPlay={autoPlay}
      showDots={showDots}
      arrows={arrows}
      itemClass={itemClass}
      containerClass={containerClass}
      customLeftArrow={
        <IconButton
          sx={{
            position: "absolute", left: 8, top: "50%", transform: "translateY(-50%)",
            boxShadow: 1, bgcolor: "background.paper", "&:hover": { bgcolor: "grey.100" }
          }}
          className="left-arrow"
        >
          <ChevronLeft />
        </IconButton>
      }
      customRightArrow={
        <IconButton
          sx={{
            position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)",
            boxShadow: 1, bgcolor: "background.paper", "&:hover": { bgcolor: "grey.100" }
          }}
          className="right-arrow"
        >
          <ChevronRight />
        </IconButton>
      }
    >
      {items.map((item, index) => renderItem(item, index))}
    </Carousel>
  );
};

export default ReusableCarousel;
